import { isString } from './isString';

export function classNames(...list) {
  return list.flat().filter(isString).join(' ');
}
